module.exports = { "default": require("core-js/library/fn/object/keys"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/object/keys.js
// module id = 45
// module chunks = 0


// WEBPACK FOOTER //
// webpack:///~/babel-runtime/core-js/object/keys.js